<template>
	<div>
		<div class="sections">
			<section>
				<h3>Bitte wähle den nächsten Schritt aus</h3>
				<RadioGroup
					v-model="followUp"
					:options="followUpOptions"
					stacked
				/>
			</section>
			<section v-if="followUpInterested">
				<h3>Interesse am besprochenen Job bei {{ companyName }}</h3>
				<RadioGroup
					v-model="interest"
					:options="interestOptions"
					stacked
				/>
			</section>
			<ApplicantSendOff
				v-if="followUpSendoff"
				v-model="sendOffData"
				:customer="message.customer"
				:with-company-name="false"
				:is-anonymous="false"
				class="mt-3"
			/>
			<div class="mt-3 text-right">
				<Button
					text="Senden"
					icon="checkmark"
					:disabled="!dataValid || sendingRequest"
					:loading="sendingRequest"
					@click="submit"
				/>
			</div>
		</div>
	</div>
</template>

<script>
import FormGroup from "@/vue/common/form/Group"
import RadioGroup from "@/vue/common/form/RadioGroup";
import Button from "@/vue/common/Button";
import {isDefined} from "@/helper/Value";
import ApplicantSendOff from "@/vue/communication/conversation/ApplicantSendOff";
import InfoBox from "@/vue/common/InfoBox";
import ArrowLink from "@/vue/common/ArrowLink";
import CustomerInterested from "@/vue/communication/conversation/CustomerInterested";
import Reply, {
	ACTION_APPLICANT_INTERESTED_IN_COLLABORATION,
	ACTION_APPLICANT_INTERESTED_IN_COLLABORATION_WANTS_TO_WAIT,
	ACTION_SENDOFF
} from "@/api/communication/conversation/message/Reply";
import flatten from "@/helper/error/Errors";
import JonInfo from "@/vue/common/JonInfo.vue";
import * as Toast from "@/helper/layout/Toast";
import {error} from "@/helper/Log";

const FOLLOW_UP_INTERESTED = 'interested';
const FOLLOW_UP_COLLABORATION = 'collaboration';
const FOLLOW_UP_SENDOFF = 'sendoff';

const INTEREST_SEND = 'send';
const INTEREST_WAIT = 'wait';

export default {

	components: {
		JonInfo,
		Button,
		FormGroup,
		InfoBox,
		RadioGroup,
		ApplicantSendOff,
		ArrowLink,
		CustomerInterested,
	},

	props: {
		message: {
			type: Object,
			required: true,
		}
	},

	data ()
	{
		return {
			followUp: undefined,
			sendOffData: undefined,
			sendingRequest: false,
			makeAppointmentData: undefined,
			interest: undefined,
		};
	},

	computed: {
		companyName ()
		{
			return this.message.customer.companyName;
		},
		followUpOptions ()
		{
			return [
				{value: FOLLOW_UP_INTERESTED, text: 'Interesse am besprochenen Job besteht'},
				// {value: FOLLOW_UP_COLLABORATION, text: 'Zusage mitteilen zum besprochenen Job'},
				{value: FOLLOW_UP_SENDOFF, text: 'Verabschieden vom besprochenen Job oder von ' + this.companyName},
			];
		},
		interestOptions ()
		{
			return [
				{
					value: INTEREST_SEND,
					text: 'Ich bin an den besprochenen Möglichkeiten / dem Job interessiert und möchte das auch ' +
						this.companyName + ' mitteilen. - Du erhältst auch eine Mitteilung von ' +
						this.companyName + '.'
				},
				{
					value: INTEREST_WAIT,
					text: 'Ich bin an den besprochenen Möglichkeiten / dem Job interessiert, aber möchte warten bis ' +
						this.companyName + ' mir diesbezüglich etwas mitteilt.'
				},
			];
		},
		followUpValid ()
		{
			return isDefined(this.followUp);
		},
		followUpCollaboration ()
		{
			return this.followUp === FOLLOW_UP_COLLABORATION;
		},
		followUpInterested ()
		{
			return this.followUp === FOLLOW_UP_INTERESTED;
		},
		followUpSendoff ()
		{
			return this.followUp === FOLLOW_UP_SENDOFF;
		},
		interestValid ()
		{
			return !this.followUpInterested || isDefined(this.interest);
		},
		sendOffValid ()
		{
			return !this.followUpSendoff || isDefined(this.sendOffData);
		},
		dataValid ()
		{
			return this.followUpValid
				&& this.interestValid
				&& this.sendOffValid;
		}
	},

	methods: {
		async submit ()
		{
			this.sendingRequest = true;

			try
			{
				let action = undefined;

				if (this.followUpSendoff)
				{
					action = ACTION_SENDOFF;
				}

				if (this.followUpInterested)
				{
					action = this.interest === INTEREST_WAIT
						? ACTION_APPLICANT_INTERESTED_IN_COLLABORATION_WANTS_TO_WAIT
						: ACTION_APPLICANT_INTERESTED_IN_COLLABORATION;
				}

				// if (this.followUpCollaboration)
				// {
				// 	action = ACTION_APPLICANT_COLLABORATION_WILLINGNESS;
				// }

				const reply = new Reply()
					.setMessageId(this.message.id)
					.setAction(action);

				if (this.followUpSendoff)
				{
					reply.setCustomerUninterestingType(this.sendOffData.customerUninterestingType);
				}

				await reply.call();

				if (this.followUpInterested)
				{
					this.$emit('responded');
				}
				else
				{
					this.$emit('processed');
				}
			}
			catch (e)
			{
				error(e);
				Toast.error(this, flatten(e.errors));
			}

			this.sendingRequest = false;
		},
	}
}
</script>
